/**
 * Launch-promo banner — REMOVED. The component is now a no-op that renders
 * nothing, so existing mounts (landing/pricing/dashboard) show no promo.
 * The named exports below are still used for cosmetic "Pricing" nav hiding,
 * so they stay. PROMO_END_ISO is kept in sync with backend PlanLimits.
 */
const PROMO_END_ISO  = '2026-08-22T23:59:59+05:30';
const PROMO_END_DISPLAY = '22 August 2026';

export default function PromoBanner() {
  return null;
}

export { PROMO_END_ISO, PROMO_END_DISPLAY };

/**
 * Helper for other components to check whether the promo is still active.
 * Frontend feature gates use user.effectivePlan from /me; this is just for
 * banner visibility + cosmetic "Pricing" nav hiding.
 */
export function isPromoActive() {
  return new Date() <= new Date(PROMO_END_ISO);
}
